<div class="public">
  <div class="main-content container">
    <div class="header" *ngIf="headerFooterVisibilityService.isHeaderVisible$ | async">
      <img alt="logo-img" class="logo" [src]="companyLogo" />
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer *ngIf="headerFooterVisibilityService.isFooterVisible$ | async"></app-footer>
</div>
